/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Privacy_NoticeInputs */



/**
* | output |
* | --- |
* | "This chat uses artificial intelligence to generate responses. Your data remains secure and private." |
*
* @param {Chat_Privacy_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_privacy_notice = /** @type {((inputs?: Chat_Privacy_NoticeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Privacy_NoticeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Chat verwendet künstliche Intelligenz zur Generierung von Antworten. Deine Daten bleiben sicher und privat.")
	return /** @type {LocalizedString} */ ("This chat uses artificial intelligence to generate responses. Your data remains secure and private.")
});